import { c as _c } from "react/compiler-runtime";
import { CreateWaveOutcomeType } from "@/types/waves.types";
export default function CreateWaveOutcomeTypesItem(t0) {
  const $ = _c(7);
  const {
    outcomeType,
    label,
    selectedOutcomeType,
    setOutcomeType
  } = t0;
  const isActive = selectedOutcomeType === outcomeType;
  const classes = isActive ? "tw-text-primary-400 tw-ring-primary-400 tw-bg-[#202B45] tw-shadow-xl" : "tw-text-iron-300 hover:tw-text-iron-200 tw-ring-iron-700 tw-bg-iron-800 hover:tw-ring-iron-650 tw-shadow-sm";
  let t1;
  if ($[0] !== outcomeType || $[1] !== setOutcomeType) {
    t1 = () => setOutcomeType(outcomeType);
    $[0] = outcomeType;
    $[1] = setOutcomeType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `${classes} tw-text-base tw-font-semibold tw-border-0 tw-flex-1 tw-relative tw-block tw-cursor-pointer tw-rounded-lg tw-ring-1 tw-ring-inset tw-px-5 tw-py-4 focus:tw-outline-none sm:tw-flex sm:tw-items-center tw-gap-x-3 tw-transition tw-duration-300 tw-ease-out`;
  let t3;
  if ($[3] !== label || $[4] !== t1 || $[5] !== t2) {
    t3 = <button onClick={t1} type="button" className={t2}>{label}</button>;
    $[3] = label;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}